// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

import './App.css';
;

function App(Props) {
  return React.createElement("div", {
              className: "App"
            }, React.createElement("header", {
                  className: "App-header"
                }, React.createElement("h1", undefined, "Alan Cheng"), React.createElement("p", undefined, "(This website is under construction!)"), React.createElement("h3", undefined, "Hello! I'm a third-year PhD student in the Computer Science Department at Stanford University."), React.createElement("p", undefined, "I'm interested in exploring new ways to make learning more effective, engaging, and enjoyable through technology. ", "My research lies at the intersection of human-computer interaction, education, and game design.")));
}

var make = App;

export {
  make ,
  
}
/*  Not a pure module */
